import React from 'react';
import './App.css';
import ContactContent from '../components/ContactContent';
import Footer from '../components/Footer';
import LandingBanner from '../components/LandingBanner';
import Nav from '../components/Nav';


function Contact() {
  return (
    <div className="App">
      <Nav/>
      <LandingBanner/>
      <ContactContent/>
      <Footer/>
    </div>
  );
}

export default Contact;
